import * as styles from "./TimePickerItem.css";

import type { JSX } from "react";

import { useTimePickerContext } from "./TimePicker.context";
import type { TimePickerItemProps } from "./TimePicker.types";

export function TimePickerItem({
  value,
  label,
  selected,
  onSelect,
}: TimePickerItemProps): JSX.Element {
  const { size, disabled } = useTimePickerContext();

  return (
    <button
      type="button"
      role="option"
      data-slot="time-picker-item"
      data-value={value}
      data-selected={selected ? "" : undefined}
      aria-selected={selected}
      aria-disabled={disabled}
      tabIndex={selected ? 0 : -1}
      disabled={disabled}
      className={styles.item({ size })}
      onClick={() => onSelect(value)}
    >
      {label}
    </button>
  );
}
